import { render, staticRenderFns } from "./all-in-one-orders-chart.vue?vue&type=template&id=435633bc&scoped=true&"
import script from "./all-in-one-orders-chart.vue?vue&type=script&lang=js&"
export * from "./all-in-one-orders-chart.vue?vue&type=script&lang=js&"
import style0 from "./all-in-one-orders-chart.vue?vue&type=style&index=0&id=435633bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435633bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('435633bc')) {
      api.createRecord('435633bc', component.options)
    } else {
      api.reload('435633bc', component.options)
    }
    module.hot.accept("./all-in-one-orders-chart.vue?vue&type=template&id=435633bc&scoped=true&", function () {
      api.rerender('435633bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/monitoring/charts/all-in-one-orders-chart.vue"
export default component.exports